import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import '@/assets/styles/index.scss' // global css
import '@/global.less' // global style
import * as antIcons from '@ant-design/icons-vue'

import {  message} from "ant-design-vue";


message.config({
  top: `100px`, // 到页面顶部距离
});



import directive from './directive' // directive

import MyIcons from './components/MyIcon/index.vue';

import router from './router'
import store from './store'
import './permission' 


const app = createApp(App);

directive(app)

Object.keys(antIcons).forEach((key) => {
  app.component(key, antIcons[key])
})
app.config.globalProperties.$antIcons = antIcons






app.component('MyIcon', MyIcons); 



app.use(store).use(Antd).use(router).use(message).mount('#app');
